import { createSlice } from '@reduxjs/toolkit';

const initialState = {};
export const educationalQualificationSlice = createSlice({
  name: 'educationDetails',
  initialState,
  reducers: {
    resetEducationQualification: (state) => initialState,
    addEducationDetails: (state, action) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { resetEducationQualification, addEducationDetails } = educationalQualificationSlice.actions;

export default educationalQualificationSlice.reducer;
